// Chemins relatifs à la base `/api/v1` du client HTTP.
const base = (caseId: string) => `/compliance/kyb/legal-entity-cases/${caseId}/signature-grids`;

const kybSignatureGridEndpoints = {
  operationTypes: (caseId: string) => `${base(caseId)}/operation-types`,
  grids: (caseId: string) => base(caseId),
  grid: (caseId: string, gridId: string) => `${base(caseId)}/${gridId}`,
  activationMfaChallenge: (caseId: string, gridId: string) => `${base(caseId)}/${gridId}/activation/mfa-challenge`,
  activation: (caseId: string, gridId: string) => `${base(caseId)}/${gridId}/activation`,
  simulation: (caseId: string) => `${base(caseId)}/simulation`,
};

export default kybSignatureGridEndpoints;
